interface QuotaData {
  allowed: boolean
  used: number
  dailyLimit: number
  remaining: number
}

interface UsageCardProps {
  manualChecks: { used: number; limit: number }
  keywordLimits: { used: number; limit: number }
}

function getProgressColor(ratio: number): string {
  if (ratio >= 0.9) return '#EF4444'
  if (ratio >= 0.7) return '#FBBF24'
  return '#6366F1'
}

export default function UsageCard({ manualChecks, keywordLimits }: UsageCardProps) {
  const checkRatio = manualChecks.limit > 0 ? manualChecks.used / manualChecks.limit : 0
  const kwRatio = keywordLimits.limit > 0 ? keywordLimits.used / keywordLimits.limit : 0
  const checkColor = getProgressColor(checkRatio)
  const kwColor = getProgressColor(kwRatio)

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <div className="inline-flex items-center gap-2.5 px-3.5 py-2 rounded-xl bg-white border border-[#E2E4ED]">
        <span className="text-xs text-[#555A73] font-medium whitespace-nowrap">
          Reverifications manuelles :
        </span>
        <span className="text-xs font-bold tabular-nums" style={{ color: checkColor }}>
          {manualChecks.used}/{manualChecks.limit}
        </span>
        <div className="w-16 h-1.5 rounded-full bg-[#F4F5FA] overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${Math.min(100, checkRatio * 100)}%`,
              backgroundColor: checkColor,
            }}
          />
        </div>
      </div>

      <div className="inline-flex items-center gap-2.5 px-3.5 py-2 rounded-xl bg-white border border-[#E2E4ED]">
        <span className="text-xs text-[#555A73] font-medium whitespace-nowrap">
          Limites des mots-cles :
        </span>
        <span className="text-xs font-bold tabular-nums" style={{ color: kwColor }}>
          {keywordLimits.used}/{keywordLimits.limit}
        </span>
        <div className="w-16 h-1.5 rounded-full bg-[#F4F5FA] overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${Math.min(100, kwRatio * 100)}%`,
              backgroundColor: kwColor,
            }}
          />
        </div>
      </div>
    </div>
  )
}
